<template>
  <div>
    <v-card
      :style="[
        $vuetify.breakpoint.smAndDown
          ? { 'min-height': '100vh', 'background-color': '#f9f9f9' }
          : { 'background-color': '#f9f9f9' },
      ]"
    >
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          Rate Profile Management
        </div>
        <v-card-text>
          <div>
            <v-card
              elevation="10"
              style="padding: 2%; margin-bottom: 2%; margin-top: 2%"
            >
              <v-row>
                <v-col cols="12" sm="6" md="2" lg="2" class="pt-5">
                  <v-select
                    :items="['Active', 'InActive']"
                    label="Status"
                    v-model="activeStatus"
                    required
                    clearable
                    outlined
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pt-5">
                  <v-text-field
                    label="Search"
                    append-icon="mdi-database-search-outline"
                    v-model="search"
                    v-on:keyup.enter="SearchRate(search)"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <!-- <v-col cols="12" sm="6" md="4" lg="4" style="text-align: end">
             
                </v-col> -->
                <v-col cols="12" sm="6" md="6" lg="6" style="text-align: end">
                  <v-hover v-slot="{ hover }">
                    <v-btn
                      :color="'blue'"
                      class="ma-2 white--text"
                      :elevation="hover ? 10 : 2"
                      :class="{ 'on-hover': hover }"
                      @click="SearchRate(search)"
                    >
                      Search

                      <v-icon right> mdi-magnify </v-icon>
                    </v-btn>
                  </v-hover>
                  <v-hover v-slot="{ hover }">
                    <v-btn
                      v-if="permissionsPage.create"
                      color="green"
                      class="ma-2 white--text"
                      :elevation="hover ? 10 : 2"
                      :class="{ 'on-hover': hover }"
                      @click="OpenRateDialog('create', null)"
                    >
                      Create
                      <v-icon right> mdi-plus </v-icon>
                    </v-btn>
                  </v-hover>
                </v-col>
              </v-row>
            </v-card>

            <v-card
              elevation="10"
              style="padding: 2%; margin-top: 2%; margin-bottom: 2%"
            >
              <v-row>
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="5" align="center">
                  <v-pagination
                    v-model="page"
                    :total-visible="6"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers"
                :items="RateList"
                hide-default-footer
                style="color: #332f2fde"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                single-line
                hide-details
              >
                <template v-slot:item="{ item, index }">
                  <tr>
                    <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                    <td class="header-table-css">{{ item.profileNameTH }}</td>
                    <td class="header-table-css">{{ item.profileNameEng }}</td>
                    <!-- <td class="header-table-css">{{ item.profileTime }}</td>
                    <td class="header-table-css">{{ item.amount }}</td> -->
                    <!-- <td class="header-table-css">{{ item.startPeriod }}</td>
                    <td class="header-table-css">{{ item.endPeriod }}</td> -->

                    <td
                      style="
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: column-reverse;
                        align-items: center;
                      "
                    >
                      <v-btn
                        :color="GetColor(item.active)"
                        rounded
                        class="text-capitalize"
                        depressed
                        style="width: 140px"
                      >
                        <span :style="{ color: GetColorText(item.active) }">{{
                          item.active == true ? "Active" : "InActive"
                        }}</span>
                      </v-btn>
                    </td>
                    <td style="text-align: center; min-width: 150px">
                      <v-btn
                        class="mx-2"
                        fab
                        dark
                        small
                        color="orange"
                        @click="OpenRateDialog('edit', item)"
                      >
                        <v-icon dark> mdi-pencil-outline </v-icon>
                      </v-btn>
                      <v-btn
                        v-if="permissionsPage.delete"
                        class="mx-2"
                        fab
                        dark
                        small
                        color="red"
                        @click="inActiveRateByRateID(item.rateID)"
                      >
                        <v-icon dark>mdi-trash-can-outline </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <br />
              <v-row class="mt-5">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3">
                  <v-pagination
                    v-model="page"
                    :total-visible="20"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete
                    dense
                    solo
                    label="10/page"
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    :items="items"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="RateDialog" persistent max-width="700px">
      <v-card>
        <v-card-title style="background-color: black; color: white; padding: 5px;">
          <v-col cols="6" sm="6" md="6" style="text-align: start">
            <span v-if="EditStatus" class="text-h5">Edit Rate Profile</span>
            <span v-else class="text-h5">Create Rate Profile</span>
          </v-col>
          <v-col cols="6" sm="6" md="6" style="text-align: end">
            <v-tooltip bottom color="white" v-if="EditStatus">
              <template v-slot:activator="{ on, attrs }">
                  <v-icon color="white" v-bind="attrs" v-on="on"> mdi-information </v-icon>
              </template>
              <v-row>
                <v-col cols="12" sm="12" md="12" style="font-size: 15px; color: black">
                  Create By : {{ createBy }} &nbsp; {{ ChangeFormatDate(createTime) }}<br />
                  Update By : {{ updateBy }} &nbsp; {{ ChangeFormatDate(updateTime) }}<br />
                </v-col>
              </v-row>
            </v-tooltip>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="5">
                <v-text-field
                  label="Profile Name*"
                  v-model="profileNameTH"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="5">
                <v-text-field
                  label=" Profile Name Eng*"
                  v-model="profileNameEng"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="2">
                <v-switch
                  v-model="Status"
                  hide-details
                  inset
                  :label="Status ? 'Active' : 'InActive'"
                ></v-switch>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="3"
                sm="3"
                md="3"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <label>ฟรีตลอด</label>
                <v-checkbox
                  v-model="freeStatus"
                  hide-details
                  class="mr-2 mt-0"
                ></v-checkbox>
              </v-col>
              <v-col
              v-if="!freeStatus"
                cols="3"
                sm="3"
                md="3"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <label>  แจ้งหนี้ผู้เช่า</label>
                <v-checkbox
                  v-model="invoiceStatus"
                  hide-details
                  class="mr-2 mt-0"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row class="mt-4" v-if="!freeStatus" >
              <v-col
                cols="3"
                sm="3"
                md="3"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <label>เหมาจ่าย</label>
                <v-checkbox
                  v-model="lumpSumStatus"
                  hide-details
                  class="mr-2 mt-0"
                  @change="changstatus"
                ></v-checkbox>
              </v-col>
              <v-col cols="9" sm="9" md="9" v-if="lumpSumStatus">
                <v-row>
                  <v-col cols="11" sm="6">
                    <v-text-field
                      label="ชัวโมง"
                      v-model="lumpSumTime"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="11" sm="6">
                    <v-text-field
                      label="ราคา"
                      v-model="amount"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="mt-4" v-if="!freeStatus" >
              <v-col
                cols="3"
                sm="3"
                md="3"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <label>จอดฟรี</label>
                <v-checkbox
                  v-model="hourTimeStatus"
                  hide-details
                  class="mr-2 mt-0"
                   @change="changstatushour"
                ></v-checkbox>
              </v-col>
              <v-col cols="9" sm="9" md="9" v-if="hourTimeStatus">
                <v-row>
                  <v-col cols="11" sm="6">
                    <v-text-field
                      label="ชัวโมง"
                      v-model="profileTime"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="11" sm="6">
                    <v-text-field
                      label="ราคา/ชัวโมง"
                      v-model="amount"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-4" v-if="!freeStatus" >
              <v-col
                cols="3"
                sm="3"
                md="3"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <label>ชัวโมงที่</label>
                <v-checkbox
                  v-model="sectionStatus"
                  hide-details
                  class="mr-2 mt-0"
                   @change="changstatussection"
                ></v-checkbox>
              </v-col>
              <v-col cols="9" sm="9" md="9" v-if="sectionStatus">
                <v-row>
                  <v-col cols="11" sm="6">
                    <v-text-field
                      label="ชัวโมงที่"
                      v-model="sectionTime"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="11" sm="6">
                    <v-text-field
                      label="เก็บเงิน (บาท)"
                      v-model="amount"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-4" v-if="!freeStatus" >
              <v-col
                cols="3"
                sm="3"
                md="3"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <label>เก็บเงิน</label>
                <v-checkbox
                  v-model="keptStatus"
                  hide-details
                  class="mr-2 mt-0"
                   @change="changstatuskept"
                ></v-checkbox>
              </v-col>
              <v-col cols="9" sm="9" md="9" v-if="keptStatus">
                <v-row>
                  <v-col cols="11" sm="6">
                    <v-text-field
                      label="ราคา/ชัวโมง"
                      v-model="amount"
                      required
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              style="text-align: end; margin-bottom: 20px"
            >
              <v-spacer></v-spacer>
              <v-btn
                v-if="EditStatus == false && permissionsPage.create"
                class="ma-2"
                style="min-width: 100px"
                color="success"
                @click="addRate()"
              >
                Save
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn
                v-if="EditStatus == true && permissionsPage.update"
                class="ma-2"
                style="min-width: 100px"
                color="success"
                @click="addRate()"
              >
                Update
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn
                variant="outlined"
                color="silver"
                style="min-width: 100px"
                append-icon="mdi-close-circle-outline"
                @click="RateDialog = false"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <div class="loading-box">
        <div class="inter-load">
          <div class="rect rect1"></div>
          <div class="rect rect2"></div>
          <div class="rect rect3"></div>
          <div class="rect rect4"></div>
          <div class="rect rect5"></div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { eventBus } from "../../main";

export default {
  name: "ManageRateProfile",
  components: {},
  data() {
    return {
      loader: null,
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      no_run: null,
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",

      RateList: [],
      search: "",
      activeStatus: null,
      startDate: "",
      endDate: "",
      menuStartDate: false,
      menuEndDate: false,
      RateDialog: false,
      EditStatus: false,

      // Add Edit
      rateID: 0,
      profileName: "",
      profileNameTH: "",
      profileNameEng: "",

      rateNameTH: "",
      Status: true,

      invoiceStatus: false,
      lumpSumStatus: false,
      freeStatus: false,
      periodStatus: false,
      hourTimeStatus: false,
      sectionStatus: false,

      keptStatus: false,


      amount: 0,
      profileTime: 0,
      lumpSumTime: 0,
      sectionTime: 0,

      profileID: 0,
      startPeriod: null,
      endPeriod: null,
      menu2: false,
      modal_startPeriod: false,
      modal_endPeriod: false,
      permissionsPage: [],

      createBy: "",
      createTime: "",
      updateBy: "",
      updateTime: "",
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "No",
          sortable: false,
          align: "left",
        },
        {
          text: "Profile Name TH",
          align: "left",
          sortable: false,
        },
        {
          text: "Profile Name Eng",
          align: "left",
          sortable: false,
        },
        // {
        //   text: "Profile Time",
        //   align: "left",
        //   sortable: false,
        // },
        // {
        //   text: "Profile Pay",
        //   align: "left",
        //   sortable: false,
        // },

        // {
        //   text: "Start Period",
        //   align: "left",
        //   sortable: false,
        // },
        // {
        //   text: "End Period",
        //   align: "left",
        //   sortable: false,
        // },
        {
          text: "Active",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  mounted() {
    let self = this;

    let Permision = localStorage.getItem("Permision");
    if (Permision == null || Permision == "") {
      this.$router.push("/Main");
    }
    let page = localStorage.getItem("page");
    this.permissionsPage = JSON.parse(Permision).find((x) => x.appName == page);

    self.getRateProfileList();
  },

  methods: {
    getRateProfileList() {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}Rate/getMasRateProfile`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    changstatus(){
      let that = this;
      if(that.lumpSumStatus){
        that.hourTimeStatus = false;
        that.amount = 0;
        that.profileTime = 0;
        that.sectionStatus = false;
        that.keptStatus = false;
        that.sectionTime = 0;
      }
    },

    changstatushour(){
      let that = this;
      if(that.hourTimeStatus){
        that.lumpSumStatus = false;
        that.amount = 0;
        that.lumpSumTime = 0;
        that.sectionStatus = false;
        that.keptStatus = false;
        that.sectionTime = 0;
      }
    },

    changstatussection(){
      let that = this;
      if(that.sectionStatus){
        that.lumpSumStatus = false;
        that.amount = 0;
        that.lumpSumTime = 0;
        that.hourTimeStatus = false;
        that.keptStatus = false;
        that.profileTime = 0;
      }
    },

    changstatuskept(){
      let that = this;
      if(that.keptStatus){
        that.lumpSumStatus = false;
        that.amount = 0;
        that.lumpSumTime = 0;
        that.hourTimeStatus = false;
        that.sectionStatus = false;
        that.sectionTime = 0;
        that.profileTime = 0;
      }
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = value;
      let temp = {
        page: value,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}Rate/getMasRateProfile`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: value,
        search: self.search == null ? "" : self.search,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}Rate/getMasRateProfile`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    SearchRate(data) {
      let self = this;
      self.LoadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: self.itemsPerPage,
        search: data,
        active:
          self.activeStatus == "Active"
            ? true
            : self.activeStatus == null
            ? null
            : false,
      };
      axios
        .post(`${self.url}Rate/getMasRateProfile`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ChangeFormatDate(date) {
      if (!date) return null;

      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    checkVakidates() {
      let that = this;
      if (that.profileNameEng == "" || that.profileNameEng == "") {
        return true;
      } else {
        return false;
      }
    },

    addRate() {
      let that = this;
      if (that.checkVakidates()) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      that.LoadingDialog = true;

      if (!that.EditStatus) {
        let temp = {
          amount: parseInt(that.amount),
          profileNameTH: that.profileNameTH,
          profileNameEng: that.profileNameEng,
          profileTime: parseInt(that.profileTime),
          invoiceStatus: that.invoiceStatus,
          lumpSumTime: parseInt(that.lumpSumTime),
          sectionTime: parseInt(that.sectionTime),
          sectionStatus: that.sectionStatus,
          hourTimeStatus: that.hourTimeStatus,
          freeStatus: that.freeStatus,
          active: that.Status,
          periodStatus: that.periodStatus,
          lumpSumStatus: that.lumpSumStatus,

          startPeriod: that.startPeriod == null ? "00:00:00" : that.startPeriod,
          endPeriod: that.endPeriod == null ? "23:59:59" : that.endPeriod,
        };
        axios
          .post(`${that.url}Rate/addRateProfile`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              that.LoadingDialog = false;
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              that.RateDialog = false;
              that.ChangePage(that.page);
            }
            if (response.data.status == 2) {
              eventBus.$emit("logout");
            }
            // that.getRateList();
            // that.RateDialog = false;
          })
          .catch(function (error) {
            that.LoadingDialog = false;
            if (error.response.status != 404) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 900,
                text: error.response.data.message,
              });
            }
          });
      } else {
        let temp = {
          profileID: that.profileID,
          amount: parseInt(that.amount),
          profileNameTH: that.profileNameTH,
          profileNameEng: that.profileNameEng,
          profileTime: parseInt(that.profileTime),
          invoiceStatus: that.invoiceStatus,
          lumpSumTime: parseInt(that.lumpSumTime),
          hourTimeStatus: that.hourTimeStatus,
          freeStatus: that.freeStatus,
          sectionTime: parseInt(that.sectionTime),
          sectionStatus: that.sectionStatus,
          active: that.Status,
          periodStatus: that.periodStatus,
          lumpSumStatus: that.lumpSumStatus,

          startPeriod: that.startPeriod == null ? "00:00:00" : that.startPeriod,
          endPeriod: that.endPeriod == null ? "23:59:59" : that.endPeriod,
        };
        axios
          .post(`${that.url}Rate/editRateProfile`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              that.LoadingDialog = false;
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              that.RateDialog = false;
              that.ChangePage(that.page);

            }
            if (response.data.status == 2) {
              eventBus.$emit("logout");
            }
            // that.getRateList();
            // that.RateDialog = false;
          })
          .catch(function (error) {
            that.LoadingDialog = false;
            if (error.response.status != 404) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 900,
                text: error.response.data.message,
              });
            }
          });
      }
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },

    OpenRateDialog(module, data) {
      let self = this;
      console.log(data);
      if (module == "create") {
        self.EditStatus = false;
        self.amount = 0;
        self.profileNameTH = "";
        self.profileNameEng = "";
        self.profileTime = 0;
        self.lumpSumTime = 0;
        self.sectionTime = 0;
        self.invoiceStatus = false;
        self.freeStatus = false;
        self.Status = true;
        self.periodStatus = false;
        self.lumpSumStatus = false;
        self.hourTimeStatus = false;
        self.sectionStatus = false;
        self.keptStatus = false;
        self.RateDialog = true;
      } else {
        self.BindingEditData(data);
      }
    },

    inActiveRateByRateID(id) {
      let that = this;
      that.LoadingDialog = true;
      let temp = {
        rateID: id,
      };

      Swal.fire({
        title: "InActive",
        text: "Do you want to InActive this Role ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Submit",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(`${that.url}Rate/inActiveRateByRateID`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                that.SearchRate();
                Swal.fire(
                  "Deleted!",
                  "Your file has been Inactive.",
                  "success"
                );
              }
              if (response.data.status == 2) {
                eventBus.$emit("logout");
              }
              that.LoadingDialog = false;
            })
            .catch(function (error) {
              that.LoadingDialog = false;
              if (error.response.status != 404) {
                Swal.fire({
                  icon: "error",
                  title: "Error...",
                  width: 900,
                  text: error.response.data.message,
                });
              }
            });
          that.LoadingDialog = false;
        }
        that.LoadingDialog = false;
      });
    },

    BindingEditData(data) {
      let self = this;
      


      self.profileID = data.profileID;
      self.hourTimeStatus = data.hourTimeStatus;
      self.sectionStatus = data.sectionStatus;
      self.lumpSumTime = data.lumpSumTime;
      self.amount = data.amount;
      self.profileNameTH = data.profileNameTH;
      self.profileNameEng = data.profileNameEng;
      self.profileTime = data.profileTime;
      self.sectionTime = data.sectionTime;
      self.invoiceStatus = data.invoiceStatus;
      self.freeStatus = data.freeStatus;
      self.Status = data.active;
      self.periodStatus = data.periodStatus;
      self.lumpSumStatus = data.lumpSumStatus;
      self.startPeriod = data.startPeriod;
      self.endPeriod = data.endPeriod;
      self.createBy = data.createBy;
      self.createTime = data.createTime;
      self.updateBy = data.updateBy;
      self.updateTime = data.updateTime;

      if(!self.freeStatus && !self.hourTimeStatus && !self.lumpSumStatus && !self.sectionStatus){
        self.keptStatus = true;
      }
      else{
        self.keptStatus = false;
      }
      self.EditStatus = true;
      self.RateDialog = true;
    },
  },
};
</script>
<style scoped>
* >>> .v-data-table-header {
  background-color: black !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.header-table-css {
  text-align: left;
  cursor: pointer;
}

*,
::before ::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #555555;
}

.loading-box {
  width: 150px;
  height: 100px;
  border: 5px solid #f1f1f1;
  /* margin: 100px auto; */
  position: relative;
}

.inter-load {
  width: 100px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.rect {
  background: #f1f1f1;
  display: inline-block;
  height: 60px;
  width: 7px;
  margin: 0 1px;
  animation: load 1.3s infinite ease-in-out;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}
</style>
